<ion-app class="exam" [class.safe-area-hide-ipad]="isIpad">
  <dojo-app-loader />

  @if (!state.showFullScreenLoader) {
    @if (state.showLoadingBar) {
      <div class="bg-neutral-0 fixed left-0 top-0 z-[1000000] w-full" @appearDisappearWithHeight>
        <mat-progress-bar class="w-full" mode="indeterminate" />
      </div>
    }
  }
  <div
    class="flex h-full min-h-0 flex-col overflow-hidden"
    [style.--mobile-info-banner-offset.px]="state.infoBannerHeight"
  >
    <div #desktopInfoBannerContainer>
      <dojo-informative-banner *ifWideLayout />
    </div>
    <div class="min-h-0 flex-1">
      <router-outlet />
    </div>
  </div>

  <dojo-debugging-window *ngIfFeatureFlag="ExamDojoFeatureFlag.Testing">
    <ng-container actions>
      @if (state.gradedAttemptId) {
        <button (click)="openDatasetUploadDialog(state.gradedAttemptId)">
          <dojo-icon icon="flask" matTooltip="Upload dataset row" [matTooltipShowDelay]="1500"></dojo-icon>
        </button>
      }
    </ng-container>
  </dojo-debugging-window>

  <dojo-issue-report-fab *ngIfFeatureFlag="ExamDojoFeatureFlag.IssueReport" />
</ion-app>
